import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort, MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { report_leftmenu } from '../../../app-settings';
import { SessionCheckwithStaff } from '../../../app-general';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { DownloadInfrastructureReportComponent } from '../download-infrastructure-report/download-infrastructure-report.component';
import { ReportService } from '../report.service';
import { getInfraAlert } from '../report';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MainLayoutService } from '../../../main-layout/main-layout.service';
import { InfrastructureAlertsComponent } from '../../../main-layout/alerts/infrastructure-alerts/infrastructure-alerts.component';
import { SidenavComponent } from '../../../main-layout/sidenav/sidenav.component';
import { ReportHeaderComponent } from '../report-header/report-header.component';

@Component({
  selector: 'app-infrastructurereport',
  templateUrl: './infrastructurereport.component.html',
  styleUrls: ['./infrastructurereport.component.scss']
})
export class InfrastructurereportComponent implements OnInit {

  ReportType = report_leftmenu.infrastructureReport;
  private _onDestroy: Subject<void> = new Subject<void>();
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  mdcurrentScreenWidth: string = 'md';

  constructor(private reportService: ReportService, private mediaObserver: MediaObserver, public dialog: MatDialog, private router: Router,
    public mainLayoutService:MainLayoutService) { 
      mediaObserver.media$.subscribe((change: MediaChange) => {

        if (change.mqAlias == this.xscurrentScreenWidth) {
          this.setupTableforXtrasmallerwidth();
        }
        else if (change.mqAlias == this.smcurrentScreenWidth) {
          this.setupTableforsmallerwidth();
        }
        else if (change.mqAlias == this.mdcurrentScreenWidth) {
          this.setupTableformidwidth();
        }
        else {
          this.setupFullTable();
        }
      });
  }

  displayedInfraReportColumns: string[] = ['DeviceType','DeviceId', 'LForIrid', 'MacId', 'DualUTId', 'CampusName', 'BuildingName', 'FloorName','RoomName'  ];

  SiteId = "1";
  InfrastructureReport;
  InfradataSource;
  downloadinfradata;
  infraloading = true;
  infrareportedData = [];
  infradatasourceCount;

  @ViewChild('searchInfraInput') searchInfraInput: ElementRef;
  @ViewChild('Infrasort') Infrasort: MatSort;  
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();

// Infrastructure Report//
setupTableforXtrasmallerwidth() {
  this.displayedInfraReportColumns = ['DeviceType', 'DeviceId', 'RoomName',];
}

setupTableforsmallerwidth() {
  this.displayedInfraReportColumns = ['DeviceType','DeviceId', 'LForIrid','RoomName'];
}
setupTableformidwidth()
{
  this.displayedInfraReportColumns = ['DeviceType','DeviceId', 'LForIrid', 'MacId', 'DualUTId', 'CampusName', 'RoomName' ];
}
setupFullTable() { 
  this.displayedInfraReportColumns = ['DeviceType','DeviceId', 'LForIrid', 'MacId', 'DualUTId', 'CampusName', 'BuildingName', 'FloorName','RoomName' ];
}

  ngOnInit() {
    this.getInfrastructureReport()
  }

  getInfrastructureReport(): void {
  try
  {    
    this.infraloading = true;  
    this.searchInfraInput.nativeElement.value = '';
    let voiceLicense = localStorage.getItem("voice_license");
    var infraitem : getInfraAlert = 
    {
      siteId:this.SiteId, 
      authKey: localStorage.getItem("Authkey"),
      isNeedIntercom: parseInt(voiceLicense)
    }
    this.reportService.getInfrastructureReport(infraitem).pipe(takeUntil(this._onDestroy))
      .subscribe((InfrastructureReport: any[]) => {
        this.infraloading = false;
        this.InfrastructureReport = InfrastructureReport;    
        this.InfradataSource = new MatTableDataSource(this.InfrastructureReport);
        this.downloadinfradata = new MatTableDataSource(this.InfrastructureReport);
        this.InfradataSource.data = this.InfrastructureReport;
        this.downloadinfradata.data = this.InfrastructureReport;      
        setTimeout(() => {
          this.infrareportedData = [];          
          this.InfradataSource.sort = this.Infrasort;
          this.sortingDatalist_InfraReport(this.InfradataSource);
          this.downloadinfradata.sort = this.Infrasort;      
          this.sortingDatalist_InfraReport(this.downloadinfradata);  
          this.downloadinfradata.connect().subscribe(data =>           
            this.infrareportedData = data
          );       
        }, 0);        
        this.infradatasourceCount = this.InfradataSource.data.length;
        this.InfradataSource.paginator = this.paginator.toArray()[0];    
      });
    }
    catch (err) {
      throw new Error('report.component.ts' + ' - getInfrastructureReport() - ' + err.message);
    }
}

searchInfrastructureReport(filterValue: string) {
  try
  {    
    if(filterValue != null)
    {
    
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.InfradataSource.filter = filterValue;
      this.searchinfrafilter(); 
      this.infrareportedData = this.InfradataSource.filteredData;
      this.infradatasourceCount = this.infrareportedData.length;
    }
  }
  catch (err) {
    throw new Error('report.component.ts' + ' - searchInfrastructureReport() - ' + err.message);
  }
}

searchinfrafilter()
{
  var search_MacId = "";
  var search_dualutId = "";
  var search_LForIrid = "";   

  this.InfradataSource.filterPredicate = function(data, filter: string): boolean {     
          
    if(data.MacId != null)
    {              
      search_MacId = data.MacId.toLowerCase().includes(filter.toLowerCase());
    } 
    else
      search_MacId = ""; 
      
    if(data.DualUTId != null)
    {                      
      search_dualutId = data.DualUTId.toString().includes(filter);
    } 
    else
      search_dualutId = "";
      
    if(data.LForIrid != "" || data.LForIrid != null)
    {
      search_LForIrid = data.LForIrid.toString().includes(filter);
    } 
    else
      search_LForIrid = ""; 
          
    return data.RoomFullName.toLowerCase().includes(filter) || data.DeviceType.toLowerCase().includes(filter) || data.DeviceId.toString().includes(filter)
            || data.CampusFullName.toLowerCase().includes(filter) || data.BuildingFullName.toLowerCase().includes(filter) 
            || data.FloorFullName.toLowerCase().includes(filter)  || search_LForIrid || search_MacId || search_dualutId; 
    }; 
}

infrastructureReportdata() {
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  if(this.InfradataSource.filter != '')
  {
    this.downloadinfradata.data = this.InfradataSource.filteredData;
    setTimeout(() => {        
      this.InfradataSource.sort = this.Infrasort;
      this.sortingDatalist_InfraReport(this.InfradataSource);   
      this.InfradataSource.connect().subscribe(data => this.infrareportedData = data);   
   }, 0);      
  }  
  const dialogRef = this.dialog.open(DownloadInfrastructureReportComponent, {
    disableClose: true,
    width: '420px',
    height: '200px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data :  this.infrareportedData
  });
  dialogRef.afterClosed().subscribe(result => {
  });
}

sortingDatalist_InfraReport(DataSource)
{
    DataSource.sortingDataAccessor = function(data, sortHeaderId: string) {  
          
          if(sortHeaderId == 'DeviceId' || sortHeaderId == 'LForIrid' || sortHeaderId == 'DualUTId' || sortHeaderId == 'MacId')
          {               
            return data[sortHeaderId]; 
          }   
          else
          { 
            return data[sortHeaderId].toString().toLocaleLowerCase().trim('');                               
          } 
      }
}

CloseRightNav(){  
  if(SidenavComponent.isClosed == false)
  {
      this.mainLayoutService.toggleSideNavRight.emit();
  }
  if(InfrastructureAlertsComponent.isinfraClosed == false)
  {
      this.mainLayoutService.toggleinfrastructureLeft.emit("close");
  } 
  if(ReportHeaderComponent.isReportMenuClosed == false)
      {
          this.reportService.toggleReportMenuNav.emit();
  }
}
ngOnDestroy() {
  this._onDestroy.next();
   this._onDestroy.complete();
 }
}
